import { Component, OnInit } from "@angular/core";
import { ControlContainer, FormArray, FormBuilder } from "@angular/forms";
import { ContattoVO } from "@app/shared/vo/contattoVO";
import { DipendenteVO } from "@app/shared/vo/dipendenteVO";
import { ProtocolloService } from "@app/shared/services/protocollo.service";
import { DestinatarioDipendenteVO } from "@app/shared/vo/gescor/destinatario-dipendenteVO";
import { TipoDestinatarioEnum } from "@app/shared/enum/tipo-destinatario-enum";

@Component({
  selector: "app-tab-destinatari-dipendenti",
  templateUrl: "./tab-destinatari-dipendenti.component.html",
})
export class TabDestinatariDipendentiComponent implements OnInit {
  public tabDipendenti;
  messages = {
    emptyMessage: "Nessun dipendente trovato",
    totalMessage: "in totale",
  };
  listaDipendentiDiretti: ContattoVO[] = new Array<ContattoVO>();
  listaDipendentiConoscenza: ContattoVO[] = new Array<ContattoVO>();
  isCollapsedTableContent: boolean = false;
  loadingIndicator: boolean;
  public rowsDipendenti = new Array<DipendenteVO>();
  public dipendenteSearch: string;
  listaDestinatariDipendenti: DestinatarioDipendenteVO[] = new Array<
    DestinatarioDipendenteVO
  >();

  constructor(
    private parentControl: ControlContainer,
    private protocolloService: ProtocolloService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.tabDipendenti = this.parentControl.control.get(
      "formDestinatariDipendenti"
    );
  }

  public cercaDipendente() {
    this.loadingIndicator = true;
    this.dipendenteSearch = this.parentControl.control.get(
      "formDestinatariDipendenti.dipendenteSearch"
    ).value;
    this.rowsDipendenti = new Array<DipendenteVO>();
    console.log("cercaDipendente: ", this.dipendenteSearch);

    this.protocolloService.getDipendenti(this.dipendenteSearch).subscribe(
      (res) => {
        console.log("res: ", res);
        this.rowsDipendenti = res;
        this.loadingIndicator = false;
      },
      (_) => (this.loadingIndicator = false)
    );
  }

  public onSelectDipendente(dipendente: DipendenteVO, tipo: string) {
    const destArray = this.tabDipendenti.controls[
      "destinatariDipendenti"
    ] as FormArray;
    if (
      this.listaDestinatariDipendenti
        .map(function (e) {
          return e.dipendente.cf;
        })
        .indexOf(dipendente.cf) < 0
    ) {
      const destinatarioDipendenteVO = this.creaDestinatarioFromDipendente(
        dipendente,
        tipo
      );
      const destDipendente = this.fb.group({
        dipendente: {
          nome: destinatarioDipendenteVO.dipendente.nome,
          cognome: destinatarioDipendenteVO.dipendente.cognome,
          cf: destinatarioDipendenteVO.dipendente.cf,
          matricola: destinatarioDipendenteVO.dipendente.matricola,
          cmu: destinatarioDipendenteVO.dipendente.cmu,
          codiceEnte: destinatarioDipendenteVO.dipendente.codiceEnte,
          descrizioneCmu: destinatarioDipendenteVO.dipendente.descrizioneCmu,
        },
        competenza: [destinatarioDipendenteVO.competenza],
      });
      destArray.push(destDipendente);
      this.creaContatto(destinatarioDipendenteVO);
      this.listaDestinatariDipendenti.push(destinatarioDipendenteVO);
      console.log("aggiungo dipend: ", dipendente);
    }
  }

  public spostaAltroLivello(dipendenteDaSpostare: ContattoVO[], tipo: string) {
    let listaDipendentiPartenza = new Array<ContattoVO>();
    let listaDipendentiArrivo = new Array<ContattoVO>();
    let nuovoLivello: TipoDestinatarioEnum;

    if (tipo === "DIRETTO") {
      nuovoLivello = TipoDestinatarioEnum.PER_CONOSCENZA;
      listaDipendentiPartenza = this.listaDipendentiDiretti;
      listaDipendentiArrivo = this.listaDipendentiConoscenza;
      dipendenteDaSpostare[0].indirizzo = "PER_CONOSCENZA";
    } else {
      nuovoLivello = TipoDestinatarioEnum.DIRETTO;
      listaDipendentiPartenza = this.listaDipendentiConoscenza;
      listaDipendentiArrivo = this.listaDipendentiDiretti;
      dipendenteDaSpostare[0].indirizzo = "DIRETTO";
    }

    listaDipendentiPartenza = listaDipendentiPartenza.filter(
      (item) => item.idSoggetto !== dipendenteDaSpostare[0].idSoggetto
    );

    listaDipendentiArrivo.push(dipendenteDaSpostare[0]);

    if (tipo === "DIRETTO") {
      this.listaDipendentiDiretti = listaDipendentiPartenza;
      this.listaDipendentiConoscenza = listaDipendentiArrivo;
    } else {
      this.listaDipendentiConoscenza = listaDipendentiPartenza;
      this.listaDipendentiDiretti = listaDipendentiArrivo;
    }

    const destArray = this.tabDipendenti.controls[
      "destinatariDipendenti"
    ] as FormArray;
    let indiceDaAgg: number;
    for (let i = 0; i < destArray.length; i++) {
      if (destArray.at(i).value.dipendente.cf === dipendenteDaSpostare[0].idSoggetto) {
        indiceDaAgg = i;
      }
    }
    const dipDaAggiornare = new DestinatarioDipendenteVO();
    dipDaAggiornare.competenza = nuovoLivello;
    dipDaAggiornare.dipendente = destArray.at(indiceDaAgg).value.dipendente;

    destArray.at(indiceDaAgg).patchValue(dipDaAggiornare);
  }

  public aggiornaDiretti(value: any) {
    console.log("aggiornaDiretti", value);
    const missingDiretti = this.listaDipendentiDiretti.filter(
      (item) => value.indexOf(item) < 0
    );

    if (missingDiretti.length > 0) {
      this.listaDipendentiDiretti = this.listaDipendentiDiretti.filter(
        (item) => missingDiretti[0].idSoggetto !== item.idSoggetto
      );
      this.listaDestinatariDipendenti = this.listaDestinatariDipendenti.filter(
        (item) => missingDiretti[0].idSoggetto !== item.dipendente.cf
      );
    }

    const destArray = this.tabDipendenti.controls[
      "destinatariDipendenti"
    ] as FormArray;
    destArray.removeAt(
      destArray.value.findIndex(
        (destinatario) => destinatario.cf === missingDiretti[0].idSoggetto
      )
    );
  }

  public aggiornaDopoRimozione(
    listaDipendentiNew: ContattoVO[],
    competenza: string
  ) {
    let listaDipendentiOld = new Array<ContattoVO>();
    if (competenza === "DIRETTO") {
      listaDipendentiOld = this.listaDipendentiDiretti;
    } else {
      listaDipendentiOld = this.listaDipendentiConoscenza;
    }

    const missingDipendente = listaDipendentiOld.filter(
      (item) => listaDipendentiNew.indexOf(item) < 0
    );

    if (missingDipendente.length > 0) {
      listaDipendentiOld = listaDipendentiOld.filter(
        (item) => missingDipendente[0].idSoggetto !== item.idSoggetto
      );
      this.listaDestinatariDipendenti = this.listaDestinatariDipendenti.filter(
        (item) => missingDipendente[0].idSoggetto !== item.dipendente.cf
      );
    }
    if (competenza === "DIRETTO") {
      this.listaDipendentiDiretti = listaDipendentiNew;
    } else {
      this.listaDipendentiConoscenza = listaDipendentiNew;
    }
    const destArray = this.tabDipendenti.controls[
      "destinatariDipendenti"
    ] as FormArray;
    destArray.removeAt(
      destArray.value.findIndex(
        (destinatario) => destinatario.dipendente.cf === missingDipendente[0].idSoggetto
      )
    );
  }

  public creaDestinatarioFromDipendente(
    dipendente: DipendenteVO,
    tipo: string
  ): DestinatarioDipendenteVO {
    const destinatarioDipendenteVO = new DestinatarioDipendenteVO();
    destinatarioDipendenteVO.dipendente.cf = dipendente.cf;
    destinatarioDipendenteVO.dipendente.nome = dipendente.nome;
    destinatarioDipendenteVO.dipendente.cognome = dipendente.cognome;
    destinatarioDipendenteVO.dipendente.codiceEnte = dipendente.codiceEnte;
    destinatarioDipendenteVO.dipendente.matricola = dipendente.matricola;
    destinatarioDipendenteVO.dipendente.cmu = dipendente.cmu;

    if (tipo === "DIRETTO") {
      destinatarioDipendenteVO.competenza = TipoDestinatarioEnum.DIRETTO.valueOf();
    }
    if (tipo === "CONOSCENZA") {
      destinatarioDipendenteVO.competenza = TipoDestinatarioEnum.PER_CONOSCENZA.valueOf();
    }

    return destinatarioDipendenteVO;
  }

  public creaContatto(destinatarioDipendente: DestinatarioDipendenteVO) {
    const contattoVO = new ContattoVO();
    contattoVO.indirizzo = destinatarioDipendente.competenza.toString();
    contattoVO.nome =
      destinatarioDipendente.dipendente.nome +
      " " +
      destinatarioDipendente.dipendente.cognome;
    contattoVO.idSoggetto = destinatarioDipendente.dipendente.cf;
    if (destinatarioDipendente.competenza === TipoDestinatarioEnum.DIRETTO) {
      contattoVO.immagine = "./assets/img/soggstran.png";
      this.listaDipendentiDiretti.push(contattoVO);
    } else {
      contattoVO.immagine = "./assets/img/sogg.png";
      this.listaDipendentiConoscenza.push(contattoVO);
    }
  }
}
